import React, {useContext, useRef} from "react";

import {BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import {novoPedido, novoItemPedido} from '../ws/ws_pedidos'

import contexto from '../util/contexto'

import { ViewDegradeVertical } from '../componentes/ViewDegradeVertical';

import FormularioPedido from '../componentes/FormularioPedido'

import {MSG_ERRO_PADRAO, TELA_MEUS_PEDIDOS} from '../util/constantes'

import { useFocusEffect } from '@react-navigation/native';

import {salvarImagemPedido} from '../ws/ws_imagem_pedido'




export default function TelaNovoPedido(){
   
    const navegacao = new useNavigation();

	const {valorContexto} = useContext(contexto);

	const formularioPedidoRef  = useRef(null)
   
  
  
	const voltar = () => {
			
		util.print("voltar");

		if(formularioPedidoRef.current.editando()){
		
			util.print("voltar alterando");
			
			formularioPedidoRef.current.cancelarEdicao();
		}
		else	
			navegacao.replace(util.processaVoltar())

		return true;
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaNovoPedido");

		BackHandler.addEventListener('hardwareBackPress', voltar);

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
  
 
	async function salvar(pedido){
		
        let retorno  = await novoPedido(valorContexto.idUsuarioAtual, pedido.titulo, pedido.descricao, pedido.data_expiracao);

		console.log(JSON.stringify(retorno));

        if(retorno == null || retorno.id ==null){
             
			formularioPedidoRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }
		
		if(pedido.imagem!=null)
			await salvarImagemPedido(retorno.id, pedido.imagem);

		for (const item of pedido.itens) {
			
			item["id_pedido"] = retorno.id;
			
			if(await novoItemPedido(item)==null){
				
				formularioPedidoRef.current.salvarErro(MSG_ERRO_PADRAO);
				return;
			}
		}

        formularioPedidoRef.current.salvarSucesso();
	
		navegacao.replace(TELA_MEUS_PEDIDOS)
    }
  

    return (
		<ViewDegradeVertical titulo="Novo Pedido" voltar={()=>voltar()}>
			<FormularioPedido ref={formularioPedidoRef} salvar={salvar}/>
		</ViewDegradeVertical>	
	);
	
}

